
import { useQuery } from "@tanstack/react-query";
import { getArtistCommissionOffers } from "@/services/commission.service";
import { useState } from "react";
import { keepPreviousData } from "@tanstack/react-query";

export const useArtistCommissionOffers = (artistId: string, initialPage = 1) => {
  const [page, setPage] = useState(initialPage);
  
  const query = useQuery({
    queryKey: ['artist-commission-offers', artistId, page],
    queryFn: () => getArtistCommissionOffers(artistId),
    enabled: !!artistId,
    placeholderData: keepPreviousData,
    retry: 1
  });
  
  return {
    ...query,
    page,
    setPage,
    offers: query.data || [],
    totalCount: query.data ? query.data.length : 0
  };
};
